import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
}

export default function StageWrapper({ children, className, ...props }: Props): JSX.Element {
  return (
    <div className={`wrapper ${className ?? ''}`} {...props}>
      {children}
      <style jsx>{`
        .wrapper {
          display: flex;
          flex-direction: column;
          margin: 16px 20px;
        }
      `}</style>
    </div>
  );
}
